import { NodeAttributesUI } from 'lib/node/attributes-ui';
import { nui } from 'lib/nodes-ui';
import { usui } from 'lib/upsell-ui';
import { fui } from 'lib/file-attachments-ui';
import { ALLOWED_IMAGE_FILE_TYPES, IMG_PREVIEW_WIDTH, FILE_MAX_SIZE, SUBSCRIBER_FILE_MAX_SIZE } from 'lib/constants';
import { canPlayVideo, getIconNameFromExtension, getVideoDimensions } from 'lib/util';
import { getScaledImageBlob, sendFileToAmazon } from 'lib/files.js';
import store from '../store_instance';

export default async function(e) {

  if (this.canvas.isViewOnly()) return;

  e.preventDefault();
  e.stopPropagation();

  const dt = e.dataTransfer || e.clipboardData || e.originalEvent.clipboardData;

  let file;
  let previewFile = null;

  const alreadyHaveFile = Boolean(this.instance.attachedFile);
  this.prevFile = this.instance.attachedFile || null;
  if (this.prevFile) {
    this.prevFile.display_properties = Object.assign({},this.prevFile.display_properties);
    this.prevFile.file_attributes = Object.assign({},this.prevFile.file_attributes);
  }

  if (dt.items) {
    for (var i=0; i < dt.items.length; i++) {
      if (dt.items[i].kind == "file") {
        file = dt.items[i].getAsFile();
      }
    }
  } else {
    for (var i=0; i < dt.files.length; i++) {
      if (dt.files[i].type.indexOf("image") !== -1) {
        file = dt.files[i];
      }
    }
  }

  if (!file) {

    const { attributesTabTag } = canvas;

    if (attributesTabTag && attributesTabTag.draggingAttribute) {
      const { name, value } = attributesTabTag.draggingAttribute;
      if (value === null || name === null) return;
      const naui = new NodeAttributesUI({ canvas: this.canvas, nodeId: this.id });
      naui.addAttribute({ nodeId: this.id, name, value, role: 'card' });
    }

    return;
  }

  const maxFileSize = usui.isSubscriber()
    ? SUBSCRIBER_FILE_MAX_SIZE
    : FILE_MAX_SIZE;

  if (file.size > maxFileSize) {
    if (this.canvas.notificationTag) {
      this.canvas.notificationTag.show({
        message: `File is too big, please upload a file smaller than ${maxFileSize / 1000000}MB`,
        isWarning: true,
        showUpgrade: !usui.isSubscriber(),
      });
    }
    //this.canvas.setFileDraggedNode(null);
    return;
  }

  const reader = new FileReader();
  let fileAttributes;
  let defaultDisplayProperties = {};
  reader.onload = e => {
    const img = new Image();
    img.onload = () => {
      fileAttributes = {
        width: img.width,
        height: img.height,
      };

      if (file.type != 'image/gif') {
        previewFile = getScaledImageBlob(img, file.type);
      }

      if (ALLOWED_IMAGE_FILE_TYPES.includes(file.type) || canPlayVideo(file.type)) {
        defaultDisplayProperties.size = this.canvas.defaultImageSize;
      }
      store.getNode(this.id).updateNode({
        attachedFile: {
          file_url: e.target.result,
          uuid: 0,
          file_attributes: { width: img.width, height: img.height },
          file_type: file.type,
          display_properties: defaultDisplayProperties,
        },
      });
      this.updateLayers();
      this.updateTopLevelNeighborsLite();
      this.refs.spinner.classList.add('spinning');

      const { prevNodePositions, nodePositions } = nui.fixOverlaps({
        nodeTag: this,
        allowedDirections: ['right','down'],
      });
      if (nodePositions.length) {
        this.operation.updateNodePositions({
          prevNodePositions,
          nodePositions,
          prevLinkAngles: [],
          linkAngles: [],
        });
      }
    };
    img.src = e.target.result;
  };

  if (file && ALLOWED_IMAGE_FILE_TYPES.includes(file.type)) {
    reader.readAsDataURL(file);
  } else if (file) {
    let defaultDisplayProperties = {};
    if (canPlayVideo(file.type)) {
      fileAttributes = await getVideoDimensions(file);
      defaultDisplayProperties.size = this.canvas.defaultImageSize;
    }
    store.getNode(this.id).updateNode({
      attachedFile: {
        file_url: '',
        uuid: 0,
        name: file.name,
        file_attributes: fileAttributes,
        file_type: file.type,
        display_properties: defaultDisplayProperties,
      },
    });

    this.updateLayers();
    this.updateTopLevelNeighborsLite();
    this.refs.spinner.classList.add('spinning');

    const { prevNodePositions, nodePositions } = nui.fixOverlaps({
      nodeTag: this,
      allowedDirections: ['right','down'],
    });
    if (nodePositions.length) {
      this.operation.updateNodePositions({
        prevNodePositions,
        nodePositions,
        prevLinkAngles: [],
        linkAngles: [],
      });
    }
  }

  const removeSpinner = () => {
    if (this.refs.spinner) {
      this.refs.spinner.classList.remove('spinning');
    }
  };

  const updateNode = ({ fileUrl, fileUUID, previewFileUrl, name }) => {
    let defaultDisplayProperties = {};
    if (ALLOWED_IMAGE_FILE_TYPES.includes(file.type) || canPlayVideo(file.type)) {
      defaultDisplayProperties.size = this.canvas.defaultImageSize;
    }

    if (fileUrl && fileUUID) {
      store.getNode(this.id).updateNode({
        attachedFile: {
          file_url: fileUrl,
          preview_url: previewFileUrl,
          uuid: fileUUID,
          file_attributes: fileAttributes,
          display_properties: this.attachedFile && this.attachedFile.display_properties ? this.attachedFile.display_properties : defaultDisplayProperties,
          file_type: file.type || 'application/octet-stream',
          name: file.name,
        }
      });
      removeSpinner();
      this.update();
      this.updateLayers();
      this.updateTopLevelNeighborsLite();
    }
  };


  const uploadFile = async e => {
    e.preventDefault();

    const credentials = await $.ajax({
      type: 'GET',
      url: '/api/maps/upload/credentials',
      data: {
        mapId: this.canvas.store.getMapId(),
        filename: file.name
      }
    });

    const fileUUID = credentials.fileUUID;
    const fileUrl = credentials.fileUrl;
    const previewFileUrl = previewFile ? credentials.previewFileUrl : null;

    const formData = new FormData();
    formData.append('file', file);

    const recordFileUpload = result => {
      const node = store.getNode(this.id);
      let prevFile;
      if (this.prevFile) {
        const pf = this.prevFile;
        prevFile = {
          nodeUUID: this.id,
          fileUUID: pf.uuid,
          fileType: pf.file_type,
          fileSize: pf.file_size,
          fileAttributes: pf.file_attributes,
          displayProperties: pf.display_properties,
          fileUrl: pf.file_url,
          previewFileUrl: pf.preview_url,
          name: pf.name,
        };
      }

      this.operation.addFileToNode({
        nodeUUID: this.id,
        fileUUID,
        fileUrl,
        fileType: file.type || 'application/octet-stream',
        fileSize: file.size,
        fileAttributes,
        displayProperties: Object.assign({},defaultDisplayProperties),
        name: file.name,
        previewFileUrl,
        prevFile,
        onSuccess: updateNode.bind(this, { fileUrl, fileUUID, fileAttributes, previewFileUrl, name: file.name }),
        onFailure: err => console.log(err),
      });
    };


    const cleanUpFailure = err => {
      removeSpinner();
      fui.removeAttachedFile(this.id);
      this.updateTopLevelNeighborsLite();
      this.canvas.notificationTag.show({
        message: "We couldn't upload the file, please try again",
        isWarning: true
      });
    };

    if (previewFile) {
      const previewFormData = new FormData();
      previewFormData.append('file', previewFile);
      sendFileToAmazon({
        url: credentials.previewEndpointUrl,
        file: previewFile,
        onSuccess: sendFileToAmazon.bind(this, {
          url: credentials.endpoint_url,
          file,
          onSuccess: recordFileUpload,
          onFailure: cleanUpFailure,
        }),
        onFailure: cleanUpFailure,
      });
    } else {
      sendFileToAmazon({
        url: credentials.endpoint_url,
        file,
        onSuccess: recordFileUpload,
        onFailure: cleanUpFailure,
      });
    }
  };

  uploadFile(e);
  //this.canvas.setFileDraggedNode(null);
}




// WEBPACK FOOTER //
// ./starling/src/lib/node-upload.js